import React from "react";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import HomeIcon from "../../assets/icons/dashboard-icon.svg";
import QuickOrderIcon from "../../assets/icons/quickOrder-icon.svg";
import LabelCatalogIcon from "../../assets/icons/labelCatalog-icon.svg";
import OrderHistoryIcon from "../../assets/icons/orderHistory-icon.svg";
import DraftOrderIcon from "../../assets/icons/draftOrder-icon.svg";
import ADL_Sidebar_Logo from "../../assets/images/ADL_Logo_White.webp";
import { SidebarProps } from "../../interfaces/layout.interface";
import "./Sidebar.scss";

const sidebarItems = [
  {
    id: "home",
    label: "Home",
    path: "/home",
    icon: HomeIcon,
  },
  {
    id: "quickOrder",
    label: "Quick Order",
    path: "/quick-order",
    icon: QuickOrderIcon,
  },
  {
    id: "labelCatalog",
    label: "Label Catalog",
    path: "/label-catalog",
    icon: LabelCatalogIcon,
  },
  {
    id: "draftOrder",
    label: "Draft Order",
    path: "/draft-order",
    icon: DraftOrderIcon,
  },
  {
    id: "orderHistory",
    label: "Order History",
    path: "/order-history",
    icon: OrderHistoryIcon,
  },
];

const SIDEBAR_HEADER_HEIGHT = 58;

const Sidebar: React.FC<SidebarProps> = ({ drawerOpen }) => {
  const location = useLocation();

  const drawerWidth = drawerOpen ? 200 : 60;

  const drawerContent = (
    <Box
      className="drawer-content"
      sx={{
        mt: `${SIDEBAR_HEADER_HEIGHT}px`,
      }}
    >
      <Box
        className="drawer-logo"
        sx={{
          height: SIDEBAR_HEADER_HEIGHT,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: drawerOpen ? 2 : 0,
        }}
      >
        <img
          className={drawerOpen ? "sidebar-logo" : "sidebar-logo-collapsed"}
          src={ADL_Sidebar_Logo}
          style={{
            transition: "width 0.15s",
            height: 55,
            width: "auto",
            maxWidth: "100%",
            objectFit: "contain",
            display: "block",
          }}
          alt="ADL Logo"
        />
      </Box>
      <List>
        {sidebarItems.map((item) => (
          <ListItem disablePadding key={item.id} 
          // style = {item.id == "contactus" ? {bottom: "-110%", position:"absolute"} : {}}
          >
            <ListItemButton
              className={`list-item-button ${!drawerOpen ? "collapsed" : ""}`}
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "#DCDCDC2A",
                  color: "#fff",
                },
                justifyContent: drawerOpen ? "flex-start" : "center",
                alignItems: "center",
                padding: drawerOpen ? "8px 16px" : "8px",
              }}
            >
              <Box className="list-item-icon">
                <img
                  src={item.icon}
                  alt={`${item.label} Icon`}
                  className="sidebar-icon"
                />
              </Box>

              {drawerOpen && (
                <ListItemText primary={item.label} className="list-item-text" />
              )}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div className="sidebar-container">
      <Drawer
        variant="permanent"
        open={drawerOpen}
        className="drawer"
        classes={{ paper: "drawer-paper" }}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          transition: "width 0.3s",
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            transition: "width 0.3s",
            backgroundColor: "#004c88",
            color: " #FFFFFF",
          },
        }}
      >
        {drawerContent}
      </Drawer>
    </div>
  );
};

export default Sidebar;
